export const selectCategoriesList = state => state.categories.items;
export const selectCategories = state => state.categories.recipes;
export const selectCategoriesLoad = state => state.categories.isLoading;
